import { render, staticRenderFns } from "./SnacksSuccess.vue?vue&type=template&id=4e3deb8a&"
import script from "./SnacksSuccess.vue?vue&type=script&lang=js&"
export * from "./SnacksSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports